import React from 'react'
import SubHeader from '../general/SubHeader';
import Slider2 from '../assets/kumbh-banner1.jpg';
import Slider1 from '../assets/kumbh-banner2.jpg';

const Mahakumbh = () => {
    return (
        <>
            <SubHeader message="MahaKumbh" />

            <section className='py-5 bg-light'>
                <div className='container px-lg-5 px-3 text-center'>

                    <p className='sec-subheading'>Get Latest Updates</p>
                    <p className='sec-heading'>MahaKumbh Mela 2025</p>

                    <div id="carouselExampleControls" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="2000">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={Slider1} class="d-block w-100 h-auto" alt="Slider" />
                            </div>

                            <div class="carousel-item">
                                <img src={Slider2} class="d-block w-100 h-auto" alt="Slider" />
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <i class="fa-solid fa-angle-left"></i>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <i class="fa-solid fa-angle-right"></i>
                        </button>
                    </div>

                </div>
            </section>

            {/* info section */}
            <section className='bg-light pb-5'>
                <div className='container px-lg-5 px-3'>

                    <p className='fs-5 fw-semibold'>The Maha Kumbh 2025 will be held in Prayagraj from January 13 to February 26.
                        This sacred Hindu festival takes place every 12 years and involves taking holy dips in the river for spiritual cleansing. This sacred event occurs every 12 years and is rooted in the ancient mythology of the Samudra Manthan—a cosmic battle between the gods and demons over the nectar of immortality.<br /><br />
                        Key bathing dates, known as 'Shahi Snan', include: -<br />
                        <span className='fst-italic text-success'>
                            Makar Sankranti (First Shahi Snan): January 14, 2025<br />
                            Mauni Amavasya (Second Shahi Snan): January 29, 2025<br />
                            Basant Panchami (Third Shahi Snan): February 3, 2025<br />
                            Paush Purnima: January 13, 2025<br />
                            Achla Saptami: February 4, 2025<br />
                            Maghi Purnima: February 12, 2025<br />
                            Maha Shivratri (Final Snan): February 26, 2025</span></p>

                </div>
            </section>

        </>
    )
}

export default Mahakumbh
